<template>
  <!-- 客户列表 -->
  <div class="runRange">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleEdit('')"
          >新增经营范围</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="编号"
      >
      </el-table-column>
      <el-table-column
        prop="entId"
        label="机构编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        align="center"
        show-overflow-tooltip
        label="排序"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            type="danger"
            plain
            style="padding: 2px 3px"
            @click="handleDel(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加管理员 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">经营范围</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                style="width: 200px"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>维护客户经营范围选项</p>
        <p>
          使用说明：<span style="font-weight: bold">客户列表->编辑</span
          >经营返回进行绑定
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "runRange",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: '分类ID',
      //   entId: '机构ID',
      //   name: '名称',
      //   sort: '排序',
      // }
      tableData: [],
      /**分页数据 */
      selectedList: [],
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增管理员drawer */
      addDrawer: false,
      /**表单数据 */
      addForm: {
        id: "",
        name: "",
        sort: "",
      },
      /**表单验证 */
      formRule: {
        name: [mustFill],
        sort: [mustFill],
      },
      /**搜索表单 */
      searchForm: {
        name: "",
      },
      // 操作说明
      explain: false,
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.getTableData(1);
    },
    // 获取表格信息
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        entId: window.localStorage.getItem("entId"),
        channel_id: 12,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        sqlValue: this.searchForm.name,
        keyId: 0,
      };
      this.$request({
        method: "post",
        url: "Base/GetTableCategory",
        data: data,
      })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.tableData = res.list.map((item) => ({
              id: item.Id,
              entId: item.entId,
              name: item.title,
              sort: item.sort_id,
            }));
            this.allPage = res.toTal;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**编辑表格数据 */
    handleEdit(row) {
      this.clearForm();
      if (row) {
        this.addForm.id = row.id;
        this.addForm.name = row.name;
        this.addForm.sort = row.sort;
      }
      this.addDrawer = true;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        // this.deteDel(row);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            keyIdList: row.id,
            entId: row.entId,
          };
          this.$request({
            method: "post",
            url: "Base/DltTableCategory",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = { id: "", name: "", sort: "" };
      this.addDrawer = false;
    },
    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            id: this.addForm.id || 0,
            channel_id: 12,
            title: this.addForm.name,
            sort_id: this.addForm.sort,
          };
          this.$request({
            method: "post",
            url: "Base/SaveTableCategory",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
                this.clearForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.runRange {
  width: 100%;
  height: 100%;
}
</style>
